export const CHART_ROW_HEIGHT = 400;
export const TOTAL_COLORS = 7;
